import { render, staticRenderFns } from "./WUserView.vue?vue&type=template&id=33bdb884&"
import script from "./WUserView.vue?vue&type=script&lang=ts&"
export * from "./WUserView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports